import { createAsyncThunk } from "@reduxjs/toolkit";
import { makeRequest } from "../../utilities/api";

export const getDashboardData = createAsyncThunk("getDashboardData", async (values, { rejectWithValue }) => makeRequest("/dashboards/lists", "GET", values, rejectWithValue));

export const getStats = createAsyncThunk("getStats", async (values, { rejectWithValue }) => makeRequest("/users/dashboard-stats", "GET", values, rejectWithValue));
